



















import { VTooltip, VIcon } from 'vuetify/lib'
import { mdiLightbulb } from '@mdi/js'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  inheritAttrs: false,
  name: 'base-tooltip-help',
  components: {
    VTooltip,
    VIcon
  },
  props: {
    content: String,
    bottom: {
      type: Boolean,
      default: true
    }
  },
  setup () {
    return { mdiLightbulb }
  }
})
